import { ReactNode } from "react";
import { cn } from "@boostdev/design-system-components/utils";
import css from "./SectionContainer.module.css";

interface MainContainerProps {
  children: ReactNode;
  className?: string;
}

export function SectionContainer({ children, className }: MainContainerProps) {
  return (
    <section className={cn([css.sectionContent, className])}>
      {children}
    </section>
  );
}
